import baseService from '@/services/baseService';
import createCacheService from '@/services/cacheService'

const cacheService = createCacheService()

export default {
    ...baseService,

    getBaseUrl() {
        this.baseUrl = process.env.VUE_APP_USERS_DEFAULT_API_URL;
        return this.baseUrl;
    },

    getMe(){
        let cachekey = 'currentuser'
        const cached = cacheService.getCache(cachekey)
        if (cached !== null) {
          return Promise.resolve(cached)
        }

        return this.axiosGet('/me').then((data) => {
          cacheService.setCache(cachekey, data)
          return data
        })
    },

    getRole() {
        return this.getMe().then((response) => {
            const user = response?.data || response;
            return user?.role ?? null;
        });
    },

    clearMeCache(){
        cacheService.flushLocalCacheByPrefix('app_cache:currentuser');
    },

    getAllUsers(){
        return this.axiosGet('?limit=10000');
    },

    getUser(id){
        return this.axiosGet(`/${id}`);
    },

    addUser(data){
        return this.axiosPost('/',data);
    },

    updateUser(id, data){
        return this.axiosPatch('/'+id,data);
    },

    recreateUserApiToken(id){
        return this.axiosPost('/'+id+'/refresh_api_token');
    },

    deleteUser(id){
        return this.axiosPost('/'+id+'/delete');
    }
}